export enum SocketStatus {
  CONNECTED = 'Connected',
  DISCONNECTED = 'Disconnected',
  UNKNOWN = 'unknown',
}

export const TIME_TO_RELOAD = 10000;
